import { TAuthType } from "./auth-type"

export function getAuthenticatedLinkIfFromReservedArea(
  origLink: string,
  authToken?: string,
  authType: TAuthType = "classic",
) {
  try {
    const url = origLink.startsWith("/")
      ? new URL(origLink, window.location.origin)
      : new URL(origLink)

    const isRedirectingToReservedArea = url
      .toString()
      .startsWith(window.APP_REDIRECT_AR)

    if (isRedirectingToReservedArea && authToken != null) {
      url.searchParams.set("auth-token", authToken)
      if (authType === "sso") {
        url.searchParams.set("auth-type", "sso")
      }
      return url.toString()
    }

    return origLink
  } catch {
    console.error(`Error in getAuthenticatedLink parsing ${origLink}`)
    return null
  }
}
